import { render, staticRenderFns } from "./BoardCardsAdmin.vue?vue&type=template&id=31effb9f&"
import script from "./BoardCardsAdmin.vue?vue&type=script&lang=js&"
export * from "./BoardCardsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports